<template>
    <b-modal
        v-model="modalShow"
        size="md"
        title="英語化問診票作成完了"
        hide-footer
        :hide-header-close="isCompleted"
        :no-close-on-backdrop="isCompleted"
        :no-close-on-esc="isCompleted"
        @hidden="close">
        <div
            v-if="isCompleted"
            class="mb-3">
            <h3 class="text-center mt-2 mb-3">英語化問診票送信完了</h3>
            <div class="mb-4">ヨクミルに登録されているメールアドレスに、英語化問診票のPDFデータを送信しました。 ダウンロードして印刷し、医療機関を受信する際にお持ちください。</div>

            <b-button
                class="nextButton"
                @click="closeAll">
                ダッシュボードへ
            </b-button>
        </div>
        <div
            v-else
            class="mb-3">
            <div>英語化問診票の作成が完了しました。ヨクミルに登録されているメールアドレスに、英語化問診票のPDFデータを送信します。よろしければ、「英語化問診票を送信」ボタンを押してください。</div>

            <b-button
                class="nextButton mt-4"
                :disabled="inProgress"
                @click="handleOk">
                {{ inProgress ? '処理中です…' : '英語化問診票を送信' }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'
    import {mapMutations} from "vuex";

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                inProgress: false,
                isCompleted: false,
                errors: {},
            }
        },

        created: function() {
            bus.$on('open-modal-user-interview-trans-completed', this.open)
            bus.$on('user-interview-trans-completed', this.close)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-user-interview-trans-completed')
            bus.$off('user-interview-trans-completed')
        },

        methods: {
            ...mapMutations({
                clearStates: 'userInterviewTransAnswers/clearStates',
            }),

            /**
             * モーダル表示
             */
            open: function () {
                this.isCompleted = false
                this.modalShow = true
            },

            /**
             * モーダル非表示
             */
            close: function() {
                this.modalShow = false
            },

            /**
             * 英語化問診の関連モーダル全てを非表示
             */
            closeAll: function () {
                this.clearStates()
                bus.$emit('user-interview-trans-completed')
            },

            /**
             * 「英語化問診票を送信」ボタン押下時
             * @param {object} e
             */
            handleOk: async function(e) {
                e.preventDefault()

                if (this.inProgress) return
                this.inProgress = true

                const endpoint = constants.user.interview_trans_profiles.endpoint.base
                const profile = this.$store.state.userInterviewTransAnswers.transProfile

                await axios.get(`${endpoint}/${profile.id}/export`)
                    .then(({data}) => {
                        this.errors = {}
                        this.isCompleted = true
                    })
                    .catch( ({response}) => {
                        this.errors = response.data.errors
                        bus.$emit('alert-danger')
                    })

                this.inProgress = false
            },
        },
    }
</script>

<style lang="scss" scoped>
.nextButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}

.customFormBtn {
    display: block;
    width: 70px;
    height: 37px;
    line-height: 37px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    background-color: #75A4FF;
    border: none;
    border-radius: 6px;
    cursor: pointer;
}
</style>
